import { camelCase } from 'lodash';

export class PointOfInterest {
  id?: number = null;
  name?: string = null;
  latitude: number = null;
  longitude: number = null;
  purpose?: string = null;
  radius?: number = null;
  poiCustomerId?: number = null;

  get latLngLiteral(): google.maps.LatLngLiteral {
    return {lat: +this.latitude, lng: +this.longitude};
  }

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
